<template>
    <MonitorLayoutTemplate
        :table_title="table_title"
        :is_show_chart_dialog="is_show_chart_dialog"
    >
        <template #datetime>
            <QpeDatetime
                :props_date="date"
                :props_time="time"
                :name="default_value"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
            />
        </template>

        <template #data_table="slot_props">
            <QpeDatatable
                :data="table_data"
                :headers="header"
                :name="default_value"
                :error_text="error_text"
                :search="slot_props.search"
                :should_draw_diagram_header="should_draw_diagram_header"
                :enable_diagram_slot="true"
                :enable_table_label="true"
                :table_label_function="calc_accumulated_precp_level"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
                @open-chart="assign_chart_component"
                :is_show_chart_dialog_parent.sync="is_show_chart_dialog"
            >
                <template #diagram_dialog="{ close_dialog }">
                    <GisChart v-if="is_show_chart_dialog"
                        id="belongs_monitor_chart"
                        :chart_options="chart_options"
                        :default_variable="$t('__rainfall.rainfall')"
                        :prop_rain_selected="current_table_header"
                        @close-chart-dialog="close_dialog"
                    />
                </template>
                <template #table_description>
                    <span>說明："--"標示，顯示該欄位無資料。 </span><br>
                    <span>警示條件:</span><br>
                    <span>10分鐘累積雨量 > 15mm</span><br>
                    <span>1小時累積雨量 > 50mm</span><br>
                </template>
            </QpeDatatable>
        </template>
    </MonitorLayoutTemplate>
</template>

<script>
    import { redirect_monitor_table_ajax } from "@/utils/monitor/monitor.js"
    import { sort_float_callback_by_given_key, calc_accumulated_precp_level } from "@/utils/monitor/common_tool.js"
    import { get_stations_history_params } from "@/utils/chart/chart_ajax.js"
    import { monitor_mixin } from "@/utils/monitor/monitor_mixin.js"
    import { TABLE_VALUE_TEXT_MAPPING } from "@/config/monitor_config.js"
    import MonitorLayoutTemplate from "@/components/monitor/_tool/layout_template.vue"
    import QpeDatetime from "@/components/monitor/qpe_datetime.vue"
    import QpeDatatable from "../qpe_datatable.vue"

    export default {
        name: 'ShortTermRainfall',

        components: {
            MonitorLayoutTemplate,
            QpeDatetime,
            QpeDatatable, 
            GisChart: () => import('@/components/chart/gis_chart.vue')
        },

        mixins: [monitor_mixin],

        data() {
            return {
                header: [],
                table_data: [],
                default_value: 248,
                error_text: '',

                should_draw_diagram_header: ['10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時', '48小時', '72小時'],

                is_show_chart_dialog: false,
                chart_options: {
                    type: { 'gauge': true }
                },
                current_table_header: '',
                
                search: '',
                calc_accumulated_precp_level: calc_accumulated_precp_level,
            }
        },
        
        computed: {
            table_title() {
                return `${TABLE_VALUE_TEXT_MAPPING[this.default_value]['tag_name']}資訊`
            }
        },

        created() {
            redirect_monitor_table_ajax.call(this, this.default_value)
        },
        
        methods: {
            generate_table_data(data, header) {
                this.immutable_table_data = data;
                this.table_data = this.sort_table_data(data);
                this.header = header;
            },

            assign_chart_component(header_name, choosed_value, current_row_data) {
                this.current_table_header = header_name
                this.chart_options = { ...this.chart_options, ...get_stations_history_params.call(this, current_row_data) }
            },

            sort_table_data(data){
                const sort_by_24h_precp = sort_float_callback_by_given_key(this.$t('24小時'))
                return [...data].sort(sort_by_24h_precp)
            }
        },
    }
</script>

<style scoped>
    .description {
        padding: 5px 10px;
    }
</style>